export default function classnames (...classnames) {
  return classnames.filter(c => !!c).join(' ')
}



// WEBPACK FOOTER //
// ./inc/js/utils/classnames.js